import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppLoginContainerModel, AppLoginContainerModelUpdate, AppLoginRegistrationContainerModel, AppLoginSubjectContainerModel } from '../../../../../models/aggregates/id';
import { AppleProfile, FacebookProfile, GoogleProfile, MicrosoftSamlResponseRequest } from '../../../../../models/dbschema/auth.model';
import { ForgotPasswordInitRequestDtoModel } from '../../data-transfer-objects/forgot-password-init-request-dto.model';
import { RegistrationRequestDtoModel } from '../../data-transfer-objects/registration-request-dto.model';
import { ResendConfirmationRequestDtoModel } from '../../data-transfer-objects/resend-confirmation-request-dto.model';
import { UserConfirmationRequestModel } from '../../data-transfer-objects/user-confirmation-request.model';
import { ApiResponseModel, BasicApiResponseModel, EcomLoginResponseModel, LoginResponse } from '../shared/api-response.model';
import { ApiVisa } from '../shared/api-visa.model';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';

@Injectable({providedIn: 'root'})
export class AzureAuthenticationService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'authentication/sso-saml';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'authentication/sso-saml';
    this.httpClient = http;
  }

  verifyAzureSaml(samlDto: MicrosoftSamlResponseRequest, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/microsoft/sso-login-authorization/backoffice-ep';
    }
    const httpOptions = {
          headers: new HttpHeaders({
            'tenantCode': 'celcomdigi',
          })
    };
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl, samlDto, httpOptions);
  }

}